import * as React from "react";
import { useRouter } from "next/router";

import { useCurrentAccountId } from "@zapier/identity";

/**
 * Redirects to the login page if the user is not logged in.
 */
export function useRequireAuth() {
  const accountId = useCurrentAccountId();
  const isLoggedIn = Boolean(accountId);

  const router = useRouter();

  React.useEffect(() => {
    if (!router.isReady) {
      return;
    }

    const isEmbed = router.asPath.includes("embed");
    const shouldRedirect = !isEmbed && !isLoggedIn;

    if (shouldRedirect) {
      const redirectUrl = `/app/login?next=${encodeURIComponent(
        router.asPath
      )}`;

      // `/app/login` is handled outside this Next.js app, so force a full page
      // navigation instead of a client-side route transition.
      window.location.replace(redirectUrl);
    }
  }, [isLoggedIn, router]);
}
